import script from "./SalaryRateSelector.vue?vue&type=script&setup=true&lang=js"
export * from "./SalaryRateSelector.vue?vue&type=script&setup=true&lang=js"

import "./SalaryRateSelector.vue?vue&type=style&index=0&id=fad92c84&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fad92c84"]])

export default __exports__